export default [
    {
      path: '/',
      redirect: '/login',
      // meta: {
      //   title: '登录'
      // }
    },
    
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login/index'),
      meta: {
        title: '蜜仆'
      }
    },
    {
      path: '/home',//控制台
      name: 'home',
      component: () => import('@/views/main/console/home'),
      meta: {
        title: '蜜仆-控制台'
      },
    },
    // {
    //   path: '/task1-1',//任务列表
    //   name: 'task1-1',
    //   component: () => import('@/views/main/anxinCase/task/index1-1'),
    //   meta: {
    //     title: '蜜仆-任务列表'
    //   },
    // },
    // {
    //   path: '/console',//控制台
    //   name: 'console',
    //   component: () => import('@/views/main/console/index'),
    //   meta: {
    //     title: '蜜仆-控制台'
    //   },
    // },
    {
      path: '/main',
      name: 'main',
      component: () => import('@/views/main/index'),
      meta: {
        title: '蜜仆'
      },
    },

]
  